import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderRelatedTaxiTaxiResponseContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export enum BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsOrderRelatedTaxiTaxiResponseConsumerTaxi = {
  displayName: string;
};

export type BillingsOrderRelatedTaxiTaxiResponseContract = {
  consumerTaxi: BillingsOrderRelatedTaxiTaxiResponseConsumerTaxi;
  distanceRate: number;
  model: BillingsOrderRelatedTaxiTaxiResponseContractBillingModel;
};

export type BillingsOrderRelatedTaxiTaxiResponseCargoOrder = {
  humanId: number;
};
export type BillingsOrderRelatedTaxiTaxiResponseTransportingOrder = {
  cargoOrder: BillingsOrderRelatedTaxiTaxiResponseCargoOrder;
};

export type BillingsOrderRelatedTaxiTaxiResponseOrderForwardingAction = {
  id: string;
  contract: BillingsOrderRelatedTaxiTaxiResponseContract;
  transportingOrder: BillingsOrderRelatedTaxiTaxiResponseTransportingOrder;
};

export type BillingsOrderRelatedTaxiTaxiResponseDate = {
  id: string;
  draft: boolean;
  distance: number;
  amountForChargeHighways: number | null;
  amountForChargeHaltings: number | null;
  allContributionsAmount: number | null;
  amountForDistance: number | null;
  date: Date;
  orderForwardingAction: BillingsOrderRelatedTaxiTaxiResponseOrderForwardingAction;
  sumOfBonuses: number;
  sumOfPenalties: number;
  status: BillingsOrderRelatedTaxiTaxiResponseDateBillingStatus;
  readOnly: boolean;
};

type BillingsOrderRelatedTaxiTaxiResponse = HttpResponse<
  BillingsOrderRelatedTaxiTaxiResponseDate[]
>;

export default BillingsOrderRelatedTaxiTaxiResponse;
